import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const shiftMonth = (ym, d) => { const [y, m] = ym.split("-").map(Number); const dt = new Date(y, m - 1 + d, 1); return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`; };
export const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };
export const waLink = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;

export function MonthNav({ month, label, onChange, testId }) {
  return (
    <div className="flex items-center gap-1">
      <button onClick={() => onChange(shiftMonth(month, -1))} className="flex h-9 w-9 items-center justify-center rounded-full hover:bg-gold-light" aria-label="Previous month" data-testid={`${testId}-prev`}><ChevronLeft size={18} /></button>
      <span className="min-w-[140px] text-center text-sm font-semibold" data-testid={`${testId}-month`}>{label || month}</span>
      <button onClick={() => onChange(shiftMonth(month, 1))} className="flex h-9 w-9 items-center justify-center rounded-full hover:bg-gold-light" aria-label="Next month" data-testid={`${testId}-next`}><ChevronRight size={18} /></button>
    </div>
  );
}

export function WhatsAppLink({ text, children, testId, outline = false }) {
  const cls = outline
    ? "inline-flex items-center gap-1 rounded-md border border-[#25D366] px-3 py-2 text-sm font-semibold text-[#128C7E] hover:bg-[#25D366]/10"
    : "inline-flex items-center gap-1 rounded-md bg-[#25D366] px-3 py-2 text-sm font-semibold text-white hover:bg-[#1ebe5a]";
  return <a href={waLink(text)} target="_blank" rel="noreferrer" className={cls} data-testid={testId}>{children}</a>;
}
